import { testimonials } from '@/mocks/categories';

export default function TestimonialSection() {
  return (
    <section id="reviews" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-3">
            <div className="w-5 h-5 flex items-center justify-center rounded bg-accent-100">
              <i className="ri-group-line text-xs text-accent-600"></i>
            </div>
            <span className="text-xs font-medium text-accent-600 uppercase tracking-wider">Community</span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
            Real Hunter Reviews
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {testimonials.slice(0, 4).map((t, i) => (
              <div key={i} className="bg-background-100 rounded-xl p-5 flex flex-col">
                <div className="flex items-center gap-3 mb-4">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
                <i className="ri-double-quotes-l text-2xl text-accent-200 mb-2"></i>
                <p className="text-sm text-foreground-700 leading-relaxed flex-1">{t.quote}</p>
              </div>
            ))}
          </div>

          <div className="bg-background-100 rounded-xl overflow-hidden flex flex-col">
            <div className="h-48 overflow-hidden">
              <img
                src={testimonials[4].avatar}
                alt={testimonials[4].name}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-5 flex-1 flex flex-col justify-between bg-gradient-to-t from-background-950/80 via-background-950/30 to-transparent -mt-10 relative z-10">
              <div>
                <i className="ri-double-quotes-l text-2xl text-accent-300 mb-2 block"></i>
                <p className="text-sm text-white/90 leading-relaxed">{testimonials[4].quote}</p>
              </div>
              <div className="mt-4">
                <p className="text-sm font-semibold text-white">{testimonials[4].name}</p>
                <p className="text-xs text-white/60">{testimonials[4].role}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}